import { SortDirection } from "@tanstack/react-table"

import { serialize, request } from "api/config"
import { PaginationRequest, ResultModel } from "types/ApiResponse"
import { NewsletterGroupWithSendDateResponseDto } from "types/Newsletter"
import { AccountLicense } from "types/Technical"

const PATH_NAME = "Technical"

export const getBorgLogOnUrl = async (
  debugOverride?: boolean
): Promise<ResultModel<string>> =>
  request.get(
    `${PATH_NAME}/BorgLogOnUrl${debugOverride ? "?debugOverride=true" : ""}`
  )

export const getExpiredAccounts = async (
  pagination: PaginationRequest,
  sorting: SortDirection,
  phrase?: string
): Promise<ResultModel<AccountLicense[]>> =>
  request.get(
    `${PATH_NAME}/AccountingOffice/ExpiredAccounts${serialize({
      phrase,
      ...pagination,
      subscriptionEndDateSortingOrder:
        sorting === "asc" ? "Ascending" : "Descending"
    })}`
  )

export const getTestAccounts = async (
  pagination: PaginationRequest,
  sorting: SortDirection,
  phrase?: string
): Promise<ResultModel<AccountLicense[]>> =>
  request.get(
    `${PATH_NAME}/AccountingOffice/TestAccount${serialize({
      phrase,
      ...pagination,
      subscriptionEndDateSortingOrder:
        sorting === "asc" ? "Ascending" : "Descending"
    })}`
  )

export const removeAccount = async (
  borgId: number
): Promise<ResultModel<AccountLicense[]>> =>
  request.delete(`${PATH_NAME}/AccountingOffice/${borgId}`)

export const moveNextStage = async (): Promise<
  ResultModel<NewsletterGroupWithSendDateResponseDto>
> => request.patch("TestDispatch/MoveNext")
